import { MESSAGE_BODY_CLASS } from "@productlane/ui"

/**
 * A body we composed ourselves renders with the composer's typography; a
 * sender's own HTML keeps the spacing their mail client wrote.
 */
export const emailBodyClassName = (authoredInProductlane: boolean): string =>
	authoredInProductlane ? `email-body ${MESSAGE_BODY_CLASS}` : "email-body"
